export default "__VITE_ASSET__8c15c69f__"